<template>
  <div>Chargement...</div>
</template>
